import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import BigButton from '../components/BigButton';
import { storiesData } from '../data/stories';
import { useSpeech } from '../hooks/useSpeech';
import './Stories.css';
import './Words.css'; // Reuse grid styles

const Stories = () => {
    const history = useHistory();
    const { speak } = useSpeech();
    const [searchTerm, setSearchTerm] = useState('');

    const filteredStories = storiesData.filter(story =>
        story.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleStoryClick = (story) => {
        speak(story.title);
        setTimeout(() => {
            history.push(`/stories/${story.id}`);
        }, 500);
    };

    return (
        <Layout title="Bedtime Stories" onBack={() => history.push('/')}>
            <div className="stories-header">
                <div className="search-container">
                    <input
                        type="text"
                        placeholder="Search for a story..."
                        className="search-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="stories-count">
                    Showing {filteredStories.length} of {storiesData.length} stories
                </div>
            </div>

            <div className="words-grid">
                {filteredStories.map((story) => (
                    <BigButton
                        key={story.id}
                        label={story.title}
                        icon={story.emoji}
                        color={story.color}
                        onClick={() => handleStoryClick(story)}
                    />
                ))}
            </div>
        </Layout>
    );
};

export default Stories;
